import React, { useContext } from 'react';
import WidgetPhotosGridBoxesProps from './widget-photos-grid-boxes.props';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Icon from 'atomic/icon';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-photos-grid-boxes.scss';

const WidgetPhotosGridBoxes: React.FC<WidgetPhotosGridBoxesProps> = ({ data, config }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="w-photos-grid-boxes">
            <div className="w-photos-grid-boxes__list">
                { data.map((item, idx) => (
                    <a
                        className="w-photos-grid-boxes__list__item"
                        target={item.target}
                        href={item.url}
                        key={String(idx)}
                        rel={getLinkRelByTarget(item.target)}
                    >
                        <div className="w-photos-grid-boxes__list__item__image">
                            <picture>
                                <source srcSet={item.img} />
                                <img src={item.img} alt={item.title} />
                            </picture>
                        </div>
                        <div className="w-photos-grid-boxes__list__item__text">
                            <div style={{ color: config?.styles?.title.color }} className="w-photos-grid-boxes__list__item__text__title">
                                {item.title}
                            </div>
                            <div
                                style={{ color: config?.styles?.cta.color }}
                                key={String(idx)}
                                className="w-photos-grid-boxes__list__item__text__cta"
                            >
                                <p>{item.cta}</p>
                                <Icon name="arrow-right" size={16} color="primary" />
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default WidgetPhotosGridBoxes;
